// src/features/tidsregistering/hooks/useBalances.js
import { useState, useCallback } from 'react';
import { balancesAPI } from '../services/balances';
import { useApi } from '../../../hooks/api/useApi';

export function useBalances() {
  const [balances, setBalances] = useState([]);
  const { loading, error, execute, clearError } = useApi();

  const fetchForStaff = useCallback(async (staffMemberId) => {
    const result = await execute(() => balancesAPI.listForStaff(staffMemberId));
    if (result.success) setBalances(result.data?.balances ?? []);
    else setBalances([]);
    return result;
  }, [execute]);

  const setEntitlement = useCallback(async (absenceBalanceId, entitlementHours) => {
    return execute(() => balancesAPI.setEntitlement(absenceBalanceId, { entitlement_hours: entitlementHours }));
  }, [execute]);

  const clear = useCallback(() => setBalances([]), []);

  return { balances, loading, error, clearError, fetchForStaff, setEntitlement, clear };
}
